import { render, staticRenderFns } from "./VizProps.vue?vue&type=template&id=4dbfd9c9&scoped=true&"
import script from "./VizProps.vue?vue&type=script&lang=js&"
export * from "./VizProps.vue?vue&type=script&lang=js&"
import style0 from "./VizProps.vue?vue&type=style&index=0&id=4dbfd9c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbfd9c9",
  null
  
)

export default component.exports